<script setup lang="ts">
import { formatPrice } from '@/utils/formatPrice'

import { useUserStore } from '@/store/user/user'

const ANIMATION_TIMEOUT = 3000

const { isDesktop } = useResponsive()

const { getStatistic, setBonusWidgetState } = useUserStore()
const { statistics, isActiveBonusWidget } = storeToRefs(useUserStore())
const { isAuthenticated } = storeToRefs(useUserStore())

const bonusAmount = computed(() => statistics.value?.bonus || 0)

const showBonuses = computed(() => {
  return bonusAmount.value > 0 && isAuthenticated.value
})

const routePath = computed(() => {
  return isDesktop.value ? '/profile/orders' : '/profile'
})

onMounted(async () => {
  await getStatistic()

  setTimeout(() => setBonusWidgetState(false), ANIMATION_TIMEOUT)
})
</script>

<template>
  <transition name="ui-fade">
    <nuxt-link v-if="showBonuses" class="header-bonuses" :to="routePath">
      <nuxt-img class="header-bonuses__image" src="/bonus.svg" alt="Бонусы" />

      <the-transition-width>
        <div v-if="isActiveBonusWidget" class="header-bonuses__text">
          <div class="header-bonuses__amount">
            {{ formatPrice(bonusAmount) }}
          </div>
        </div>
      </the-transition-width>
    </nuxt-link>
  </transition>
</template>

<style scoped lang="scss">
.header-bonuses {
  display: flex;
  align-items: center;
  padding: 5px 6px;
  background-color: var(--ui-color-orange-100);
  border-radius: 6px;

  @include media('>=desktop-mini') {
    padding: 9px 12px;
    cursor: pointer;
    border-radius: 120px;
  }

  &__image {
    width: 18px;
    height: 14px;
    pointer-events: none;
    user-select: none;

    @include media('>=desktop-mini') {
      width: 28px;
      height: 22px;
    }
  }

  &__text {
    font-size: 10px;
    font-weight: 800;
    line-height: 14px;
    color: var(--ui-color-orange-800);
    white-space: nowrap;
    user-select: none;

    @include media('>=desktop-mini') {
      font-size: 16px;
      line-height: 20px;
    }
  }

  &__amount {
    padding-left: 4px;

    @include media('>=desktop-mini') {
      padding-left: 8px;
    }
  }
}
</style>
